import React from "react";
import {
  PHONE_MOBILE_DISPLAY,
  PHONE_MOBILE_HREF,
} from "../../constants/contact";

interface ButtonProps {
  // children: React.ReactNode;
  onClick?: () => void;
  variant?: String;
  size?: String;
  type?: "button" | "submit";
  fullWidth?: boolean;
  className?: String;
  isDisabled?: boolean;
}

const HeaderCallButton: React.FC<ButtonProps> = () => {
  return (
    <a
      href={PHONE_MOBILE_HREF}
      className="hidden xl:flex font-poppins items-center gap-2 bg-cred-100 text-white font-medium px-6 py-3 rounded-lg border-2 border-cred-100 hover:bg-white hover:text-cred-100 hover:border-white"
    >
      {PHONE_MOBILE_DISPLAY}
    </a>
  );
};

export default HeaderCallButton;
